module.exports = __webpack_public_path__ + "img/list_of_da_members.83509729.jpg";